<template>
    <app-dialog :contentClass="classT" v-if="value" :isConfirmationDialog="true" :value="value" @input="onDialogInput" :title="title" :width="getDialogWidth" v-bind="$attrs">
        <template v-slot:content>
            <p class="font-size-lg dark-blue-color pt-4" data-cy="app-dialog-delete-question" v-if="question">
                {{ question }}
            </p>

            <slot name="optional" />
        </template>

        <template v-slot:buttons="{}">
            <v-btn text outlined class="myprovet-btn-cancel" @click="onCloseDialog" data-cy="app-dialog-cancel-btn">
                {{ cancelText || $t('common.cancel') }}
            </v-btn>

            <v-btn text :disabled="disabled" class="myprovet-btn-ok" :loading="isLoading" @click="onConfirmDialog" data-cy="app-dialog-submit-btn">
                {{ confirmText || $t('common.ok') }}
            </v-btn>
        </template>
    </app-dialog>
</template>

<script>
export default {
    props: {
        classT:String,
        value: { default: false },
        title: String,
        question: String,
        confirmText: String,
        cancelText: String,
        isLoading: { type: Boolean, default: false },
    },

    data: () => ({
        disabled: false,
    }),

    computed: {
        getDialogWidth() {
            return this.getResponsiveDialogWidth('60vw', '35vw');
        },
    },

    watch: {
        value: {
            handler: function (value) {
                if (value) {
                    this.disabled = false;
                }
            },
            immediate: true,
        },
    },

    methods: {
        onConfirmDialog() {
            this.disabled = true;
            this.$emit('onSuccess', true);
        },

        onCloseDialog() {
            this.$emit('onCancel', false);
        },

        onDialogInput() {
            this.$emit('onCancel', false);
        },
    },
};
</script>
